import { render, staticRenderFns } from "./apiTestDoc.vue?vue&type=template&id=0abca9f7&scoped=true"
import script from "./apiTestDoc.vue?vue&type=script&lang=js"
export * from "./apiTestDoc.vue?vue&type=script&lang=js"
import style0 from "./apiTestDoc.vue?vue&type=style&index=0&id=0abca9f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abca9f7",
  null
  
)

export default component.exports